import { Space } from 'antd'

import { ThumbnailImage } from './ThumbnailImage'

interface ProductCellProps {
  name: string | null | undefined
  thumbnailUrl: string | null | undefined
}

export function ProductCell({ name, thumbnailUrl }: ProductCellProps) {
  return (
    <Space>
      <ThumbnailImage src={thumbnailUrl} alt={name ?? undefined} />
      <span>{name ?? '-'}</span>
    </Space>
  )
}
